import SelectedQuestionCard from "./selectedQuestionCard.container";
export default SelectedQuestionCard;